<template>
  <q-page padding>
    <q-list bordered separator>

      <q-item :to="{name: 'home'}" clickable>
        <q-item-section>Inicio</q-item-section>
      </q-item>

      <q-item :to="{name:'consulta-pedido'}" clickable>
        <q-item-section>
          <q-item-label>Consulta pedido</q-item-label>
          <q-item-label caption>Caption</q-item-label>
        </q-item-section>
        <q-item-section side>
          <q-icon name="description" class="text-primary" size="34px" />
        </q-item-section>
      </q-item>

      <q-item :to="{name:'apiprueba'}" clickable>
        <q-item-section>
          <q-item-label>Pruebas api</q-item-label>
          <q-item-label caption>Pruebas varias</q-item-label>
        </q-item-section>
      </q-item>

      <q-item :to="{name:'geocode'}" clickable>
        <q-item-section>
          <q-item-label>Geocode</q-item-label>
          <q-item-label caption>Pruebas google api</q-item-label>
        </q-item-section>
      </q-item>

    </q-list>

  </q-page>
</template>

<script>
import {userService} from '@/_services/user.service';
import { mapGetters } from 'vuex';

export default {
  data () {
    return {
      brand: 'SEPET'
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'getToken'])
  },
  methods: {
    
  },
  activated() {
    // console.log('Usuario token: ', this.getToken);
  }
}
</script>

<style lang="scss">
</style>
